<template>
  <btn 
  class="app-status-update-button"
  @onClick="onClick" 
  :data-id="id"
  :colour="colour"> 
  <template #text>
    {{ buttonText }}
    </template>
  </btn>
</template>

<script>
export default {
  name: 'AppStatusButton',
  props: {
    data: Object,
    confirmOrCancel: Function,
  },
  methods: {
    onClick: function(e) {
      this.confirmOrCancel(e)
    }
  },
  computed: {
    id() {
      return this.data.id;
    },
    buttonText() {
      return this.data.name ? this.data.name : '';
    },
    buttonIcon() {
      let buttonIcon = this.data.icon;
      if (buttonIcon) {
        return buttonIcon;
      } else {
        return false;
      }
    },
    colour() {
      return this.data.colour || "ghost"
    }
  },
};
</script>

<style scoped lang="scss">
@import '~@/scss/components/modals/app_status_update_button.scss';
</style>
